<template>
	<form
		class="pc-square-search"
		:class="{ 'pc-square-search--trigger': triggerOnly }"
		@submit.prevent="handleSearch"
		@click="handleTriggerClick"
	>
		<img :src="searchIcon" alt="" class="pc-square-search__icon" aria-hidden="true" />
		<input
			v-model="searchKeyword"
			type="search"
			class="pc-square-search__input"
			:placeholder="displaySearchPlaceholder"
			:readonly="triggerOnly"
			@focus="handleTriggerFocus"
		/>
		<div class="diver"></div>
		<button type="submit" class="pc-square-search__btn">{{ displaySearchButtonText }}</button>
	</form>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import searchIcon from "~/assets/images/search.png";

const props = defineProps({
	searchPlaceholder: {
		type: String,
		default: "",
	},
	searchButtonText: {
		type: String,
		default: "",
	},
	triggerOnly: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(["search", "open"]);

const { t } = useI18n();
const searchKeyword = ref("");

const displaySearchPlaceholder = computed(
	() => props.searchPlaceholder || t("common.breadcrumb.searchPlaceholder")
);
const displaySearchButtonText = computed(
	() => props.searchButtonText || t("common.breadcrumb.search")
);

const openSearch = () => {
	emit("open");
};

const handleTriggerClick = () => {
	if (!props.triggerOnly) return;
	openSearch();
};

const handleTriggerFocus = event => {
	if (!props.triggerOnly) return;
	event.target?.blur();
	openSearch();
};

const handleSearch = () => {
	if (props.triggerOnly) {
		openSearch();
		return;
	}
	emit("search", searchKeyword.value.trim());
};
</script>

<style lang="scss" scoped>
.pc-square-search {
	display: flex;
	align-items: center;
	flex-shrink: 0;
	width: 340px;
	height: 44px;
	padding: 0 16px 0 14px;
	border: 1px solid #22262a;
	border-radius: 999px;
	background: #ffffff;
	box-sizing: border-box;

	.diver {
		width: 1px;
		background: #e5e5e5;
		height: 60%;
		margin: 0 20px;
	}

	&--trigger {
		cursor: pointer;

		.pc-square-search__input {
			cursor: pointer;
		}
	}

	&__icon {
		flex-shrink: 0;
		width: 18px;
		height: 18px;
		margin-right: 10px;
		object-fit: contain;
	}

	&__input {
		flex: 1;
		min-width: 0;
		height: 100%;
		border: none;
		outline: none;
		background: transparent;
		font-size: 18px;
		color: #22262a;

		&::placeholder {
			color: #595959;
		}

		&::-webkit-search-cancel-button {
			display: none;
		}
	}

	&__btn {
		flex-shrink: 0;
		border: none;
		padding: 0;
		background: transparent;
		font-size: 20px;
		font-weight: 600;
		line-height: 1;
		color: #333333;
		cursor: pointer;
		white-space: nowrap;
	}
}
</style>
